/**
 * Olho de Hórus nas telas: `track()`, autocaptura de cliques por `data-track` e web vitals.
 * Sem `endpoint` o tracker é no-op; o coletor (`POST /v1/track`) chega na S5.
 */
import { autoCapture, createTracker, trackWebVitals } from "@odus/obs-sdk";

import { env } from "./env";

export const tracker = createTracker({ release: env.release });

export function startObs(): void {
  autoCapture(tracker);
  trackWebVitals(tracker, "app.web_vitals");
}
